/**
 * useUpdatePrompts — fan-out wrapper for the CLI + skill + MCP setup nudges.
 *
 * Composes `useCliVersionNudge`, `useSkillVersionNudge`, and
 * `useAnoMcpNudge` so the App shell mounts a single hook for "give me
 * sticky update prompts when the user's setup is incomplete." Each
 * underlying hook handles its own probe, dismissal, and toast.
 */
import { useAnoMcpNudge } from "./useAnoMcpNudge";
import { useCliVersionNudge } from "./useCliVersionNudge";
import { useSkillVersionNudge } from "./useSkillVersionNudge";

export function useUpdatePrompts(enabled: boolean): void {
  useCliVersionNudge(enabled);
  useSkillVersionNudge(enabled);
  useAnoMcpNudge(enabled);
}
